import Debug from 'debug';
import { PracticeStateMachineData } from '../data'
import { PracticeStateMachineAbstractState, PracticeStateMachineCommonEvents } from './state';

const debug = Debug('practice-summary-state')

interface Events extends PracticeStateMachineCommonEvents {
  onReviewRequested: (questionIndex: number) => void
  onReset: () => void
}

export class PracticeSummaryState extends PracticeStateMachineAbstractState<Events> {

  public readonly name = 'summary'
  
  constructor(private state: PracticeStateMachineData) {
    super()
  }

  navigate(questionIndex: number) {
    if (!this.state.isQuestionReachable(questionIndex)) {
      debug(`question '${questionIndex}' is not reachable`)
      return
    }

    this.triggerEvent(events => events.onReviewRequested(questionIndex))
  }

  enter() {
    debug('enter')
    this.state.disableNotEvaluatedQuestions()
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.endCancel()
  }

  reset() {
    debug('reset')
    this.triggerEvent(events => events.onReset())
  }
}
